export const optionLabelFormatter = (label: string) => {
  if (label.toLowerCase() === 'n/a') {
    return 'N/A';
  } else if (label.includes('_')) {
    return label.replace(/_/g, ' ');
  } else {
    return label;
  }
};
